import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@store/authStore';

interface PublicRouteProps {
  children: React.ReactNode;
}

/**
 * Route guard for public pages (redirects if already authenticated)
 */
const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuthStore();

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default PublicRoute;


